let tennis_data = [
    {
        type: '남성 0.5~1 업핏 테니스',
        name: '몬도 포르자 T9 M',
        price: '179,000원',
        imgUrl: '/img/tennis1.jpg'
    },
    {
        type: '남성 0.5~1 업핏 테니스',
        name: '몬도 포르자 T9 M',
        price: '179,000원',
        imgUrl: '/img/tennis2.jpg'
    },
    {
        type: '여성 0.5~1 업핏 테니스',
        name: '몬도 포르자 T9 W',
        price: '179,000원',
        imgUrl: '/img/tennis1.jpg'
    },
    {
        type: '여성 0.5~1 업핏 테니스',
        name: '몬도 포르자 T9 W',
        price: '179,000원',
        imgUrl: '/img/tennis2.jpg'
    },
    {
        type: '공용 테니스',
        name: '<재입고> 그리너리 테니스 라켓백',
        price: '119,000원',
        imgUrl: '/img/tennis5.jpg'
    },
    {
        type: '공용 테니스',
        name: '<재입고> 그리너리 테니스 라켓백',
        price: '119,000원',
        imgUrl: '/img/tennis6.jpg'
    },
    {
        type: '공용 테니스',
        name: '<재입고> 그리너리 테니스 라켓백',
        price: '119,000원',
        imgUrl: '/img/tennis7.jpg'
    },
    {
        type: '여성 테니스',
        name: '컬러블럭 바람막이',
        price: '149,000원',
        imgUrl: '/img/tennis8.jpg'
    },
    {
        type: '여성 테니스',
        name: '컬러블럭 바람막이',
        price: '149,000원',
        imgUrl: '/img/tennis9.jpg'
    },
    {
        type: '여성 테니스',
        name: '우븐 플리츠스커트',
        price: '99,000원',
        imgUrl: '/img/tennis10.jpg'
    },
    {
        type: '여성 테니스',
        name: '우븐 플리츠스커트',
        price: '99,000원',
        imgUrl: '/img/tennis11.jpg'
    },
    {
        type: '여성 테니스',
        name: '우븐 버뮤다 팬츠',
        price: '89,000원',
        imgUrl: '/img/tennis12.jpg'
    },
    {
        type: '여성 테니스',
        name: '우븐 버뮤다 팬츠',
        price: '89,000원',
        imgUrl: '/img/tennis13.jpg'
    },
    {
        type: '공용 테니스',
        name: '휠라 스피드서브 T9',
        price: '159,000원',
        imgUrl: '/img/tennis14.jpg'
    }
]


export default tennis_data;